import React from "react";
import { FormatBalance, GetCurrenySymbol } from "../../../../helper";

const Accounts = ({ account }) => {
  return (
    <div key={account.id} className="other-accounts-card">
      <div className="flex">
        <img src={account.logo} alt={account.title} className="other-accounts-logo" />
        <div className="ml-3">
          <p className="other-accounts-title">{account.title}</p>
          <p className="other-accounts-number">{account.account_number}</p>
        </div>
      </div>
      <div className="other-accounts-balance">
        <span className="other-accounts-balance-symbol">
          {GetCurrenySymbol(account.currency_code, "14", "14")}
        </span>
        {FormatBalance(account.balance, account.is_crypto)}
      </div>
    </div>
  );
};

export default Accounts;
